import { getUserFacingErrorMessage } from "@/api/userFacingError";
import type { CheckinItem } from "./types";

export function isShortfallClosed(item: Pick<CheckinItem, "receiving_status">) {
  return item.receiving_status === "SHORTFALL_CLOSED";
}

export function isActivePartial(item: Pick<CheckinItem, "receiving_status">) {
  return item.receiving_status === "PARTIAL";
}

export function hasSubstitutionHistory(
  item: Pick<CheckinItem, "return_status">,
) {
  return item.return_status === "SUBSTITUIDO";
}

export function getCheckinActionError(error: unknown) {
  return getUserFacingErrorMessage(error);
}
